import { Box, Divider, List } from "@chakra-ui/react"
import React, { useEffect, useRef } from "react"
import { useInViewport } from "react-in-viewport"
import { IBeaconFragment } from "../../graphql"
import { IBeaconListItem } from "./IBeaconListItem"

export type IBeaconsListProps = {
	ibeacons: IBeaconFragment[]
	zoneId?: string
	loadMore?: () => void
}

export const IBeaconsList: React.FC<IBeaconsListProps> = ({ ibeacons, zoneId, loadMore }) => {
	const ref = useRef()

	const { inViewport } = useInViewport(ref as any, { threshold: 0.25 })

	useEffect(() => {
		if (inViewport) {
			loadMore?.()
		}
	}, [inViewport, loadMore])

	return (
		<List spacing={2}>
			{ibeacons.map((ibeacon) => (
				<React.Fragment key={ibeacon._id}>
					<IBeaconListItem ibeacon={ibeacon} zoneId={zoneId} />
					<Divider />
				</React.Fragment>
			))}
			<Box w="full" h="2" ref={ref as any} />
		</List>
	)
}
